import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";

const PrizesPage: React.FC = () => {

    return(
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '80vh',
                }}
            >
                <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 2 }}>
                    <Typography variant="h2" gutterBottom>
                        Призы
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Спонсоров я пока не нашёл - поэтому бюджет всего мероприятия 100К рублей
                    </Typography>
                    <Typography variant="body1">
                        Команда победителей в каждой номинации получит по 50К рублей на команду за 1 место.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Если смогу найти спонсоров - призовой фонд будет увеличен.
                    </Typography>

                    <Typography variant="body1">
                        Если призовой фонд такой маленький, то зачем же в этом участвовать?
                    </Typography>
                    <Typography variant="body1">
                        Причин несколько:
                    </Typography>
                    <div>
                        <ul>
                            <li>Занетворкаться с людьми (без развития софт скиллов 1 место тут не занять: надо будет как искать клиентов, так и людей себе в команду)</li>
                            <li>Получить опыт создания своего продукта/услуги</li>
                            <li>Получить опыт продвижения своего продукта/услуги</li>
                            <li>Научиться зарабатывать не в найме 8/5, а самостоятельно</li>
                        </ul>
                    </div>
                </Box>
            </Box>
        </>
    )
}

export default PrizesPage;